import { render, staticRenderFns } from "./Notifications_mobile.vue?vue&type=template&id=53e4d2ba&scoped=true&"
import script from "./Notifications_mobile.vue?vue&type=script&lang=js&"
export * from "./Notifications_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Notifications_mobile.vue?vue&type=style&index=0&id=53e4d2ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4d2ba",
  null
  
)

export default component.exports